<script setup lang="ts">
import { inject } from "vue";
import { getId, mapNodes } from "~/utils/helper/magnolia";
import CallToActionComponent from "~/templates/components/cms/CallToActionComponent.vue";

const quickNavigation = inject("pageQuickNavigation", {});
const links = computed(() => mapNodes(quickNavigation.value?.links));
const mobileOnly = computed(() => quickNavigation.value?.mobileOnly ?? false);
</script>

<template>
  <nav
    aria-label="Quick Navigation"
    class="quick-navigation block w-full"
    :class="{ 'md:hidden': mobileOnly }"
  >
    <ul class="container flex items-center gap-2 overflow-x-auto py-2">
      <li v-for="quickNavigationLink in links" :key="getId(quickNavigationLink)" class="shrink-0">
        <CallToActionComponent :link="quickNavigationLink?.link" />
      </li>
    </ul>
  </nav>
</template>
